var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
export function getMarketItems(category) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = category ? `?category=${encodeURIComponent(category)}` : '';
        return client.get(`/market-items${params}`);
    });
}
export function getMarketCategories() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/market-items/categories');
    });
}
export function getMarketItemById(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/market-items/${id}`);
    });
}
export function createMarketItem(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post('/market-items', data);
    });
}
export function updateMarketItem(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/market-items/${id}`, data);
    });
}
export function deleteMarketItem(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/market-items/${id}`);
    });
}
export function restoreMarketItem(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/market-items/${id}/restore`);
    });
}
export function deleteMarketItemPermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/market-items/${id}/permanent`);
    });
}
